// extracted by mini-css-extract-plugin
export var dataCell = "_nn-2";
export var dataRow = "_nn-0";
export var headerRow = "_nn-1";